import React, { useEffect, useState } from 'react';
import { ListTable, Loading, Modal } from '../../../ui';
import { useBrokendownAnalytics } from '../../statistics/hooks/useStatisticsState';
import { useTranslation } from 'react-i18next';


const CourseUsageAnalytics = ({ courseToShow, onClose, endDate, startDate }) => {
  const { t } = useTranslation();

  const [breakdownMerged, setBreakdownMerged] = useState();

  const sessionQuery = useBrokendownAnalytics({
    courseId: courseToShow?.id,
    startDate, 
    endDate,
    dimensions: 'ga:pagePath',
    metrics: 'ga:sessions, ga:averageSessionDuration',
    filters: courseToShow?.slug,
    sort: '-ga:averageSessionDuration'
  }, { skip: !courseToShow });

  const eventsQuery = useBrokendownAnalytics({
    courseId: courseToShow?.id,
    startDate, 
    endDate,
    dimensions: 'ga:pagePath,ga:eventName',
    metrics: 'ga:eventCount',
    filters: courseToShow?.slug,
    sort: '-ga:eventCount'
  }, { skip: !courseToShow });

  const breakdownSession = sessionQuery.analytics;
  const breakdownEvents = eventsQuery.analytics;
  const isLoading = sessionQuery.isLoading || eventsQuery.isLoading;
  const isError = sessionQuery.isError || eventsQuery.isError;

  useEffect(() => {
    const newArray = []
    if (breakdownSession && breakdownEvents) {
      breakdownSession.map((item) => {
        const events = breakdownEvents.find(element => element.id === item.id);
        newArray.push({ ...item, gaDataSession: [...item?.gaData], gaDataEvent: [...events?.gaData] })
        return null
      })
    }

    if (newArray.length)
      setBreakdownMerged(newArray)


  }, [breakdownSession, breakdownEvents])

  const tableInfoSales = [
    { label: t('insights.page'), data: (course) => course.sectionName + ' - ' + course.name },
    { label: t('insights.sessions'), data: (course) => course.gaDataSession ? course.gaDataSession[0]?.sessions : '0' },
    {
      label: t('insights.AvTimeSpent'), data: (course) => {

        const convertToMin = (time) => {
          const minutes = Math.floor(time / 60);
          const seconds = Math.floor(time - minutes * 60);
          return `${minutes}.${seconds} min`
        }

        return (course.gaDataSession && course.gaDataSession[0]) ? convertToMin(course.gaDataSession[0].averageSessionDuration) : '0.0 min'
      }
    },
    { label: t('insights.interaction'), data: (course) => course.gaDataEvent && course.gaDataEvent[0]?.eventCount },
    { label: t('insights.type'), data: (course) => course.gaDataEvent && course.gaDataEvent[0]?.eventName },

  ]

  const closeHandle = () => {
    onClose()
    setBreakdownMerged()
  }

  return (
    <Modal
      open={!!courseToShow}
      onClose={closeHandle}
      title={t('insights.usageStats', { stats: courseToShow?.name })}
    >
      { isLoading ? <Loading /> :
      isError ? <div>Error we cant show this info</div>
      : <ListTable
        tableInfo={tableInfoSales}
        data={breakdownMerged}
        tableName={'usage'}
      />}
    </Modal>

  );
};

export default CourseUsageAnalytics;
